import { useState } from "react";

export const ALL_MODIFIERS = {
  size: ["sm", "md", "lg", "xl", "2xl"],
  interaction: ["hover", "focus", "active"],
  theme: ["dark"],
  form: ["required", "invalid", "disabled"],
};

export const SIZE_VALUES = {
  sm: ">= 40rem (640px)",
  md: ">= 48rem (768px)",
  lg: ">= 64rem (1024px)",
  xl: ">= 80rem (1280px)",
  "2xl": ">= 96rem (1536px)",
};

export const ALL_MODIFIERS_SET = new Set<string>(
  Object.values(ALL_MODIFIERS).flat()
);

const useModifiers = (initialModifiers = []) => {
  const [modifiers, setModifiers] = useState<string[]>(initialModifiers);

  const addModifier = (modifier: string) => {
    setModifiers((currentModifiers) => {
      const newModifiers = [...currentModifiers];
      Object.entries(ALL_MODIFIERS).forEach(([_, groupModifiers]) => {
        if (groupModifiers.includes(modifier)) {
          // Remove any modifiers from the same group
          groupModifiers.forEach((mod) => {
            const index = newModifiers.indexOf(mod);
            if (index !== -1) {
              newModifiers.splice(index, 1);
            }
          });
        }
      });
      // Add the new modifier
      newModifiers.push(modifier);
      return newModifiers;
    });
  };

  const removeModifier = (modifier: string) => {
    setModifiers((currentModifiers) =>
      currentModifiers.filter((mod) => mod !== modifier)
    );
  };

  const clearModifiers = () => {
    setModifiers([]);
  };

  return { modifiers, addModifier, removeModifier, clearModifiers };
};

export default useModifiers;
